import { LatLngTuple } from "leaflet";

// export const defaultLocation: LatLngTuple = [44.05054978666727, 4.8489237936961];
export const defaultLocation: LatLngTuple = [
  44.121734237613204, 5.02880190194809,
];
